export const servicoModais = {
  editarServicoModal: 'editarServicoModal',
  visualizarServicoModal: 'visualizarServicoModal',
  buscaAvancada: 'buscaAvancada',
};
